import "slick-slider";
import {lazyLoadSlickIframes} from "../components/slick-iframe-lazy-load";

jQuery(document).ready(($) => {


    const $slider = $('.social-posts-wrapper .posts');

    $slider.slick({
        slideToShow: 1,
        slidesToScroll: 1,
        rtl: true,
        appendArrows: $('.social-posts-header'),
        prevArrow: '<span class="social-nav social-nav-prev">< הקודם</span>',
        nextArrow: '<span class="social-nav social-nav-next">הבא ></span>',
        infinite: false
    });

    lazyLoadSlickIframes($slider);

    $('.reaction').on('click', (e) => {
        e.stopPropagation();
        $('.social-posts-wrapper .posts').slick('slickNext')
    });


    $slider.on('afterChange', function (event, slick, currentSlide) {
        $('.post-number').text(`#${currentSlide + 1}`);
    });
});